/* eslint-disable camelcase */
// The Cropr object is typed here. For now, only what is used in the frontend folder is typed.
import moment from "moment";

interface SoilType {
  id: number;
  edi_code: string;
  name: string;
  country: string | null;
}

interface FieldAttributeType {
  id: string;
  edi_code: string;
  name: string;
  variant?: string;
  visible: boolean;
}

type MessageType = "success" | "error" | "danger" | "info" | "warning";
type StockVariantType = {
  quantity: number;
  used: number;
  //etc
};
type StockVariants = "chemical" | "fertilizer" | "yield" | "delivery" | "other";
type StockPerVariantType = {
  [key in StockVariants]: {
    items: { [id: string]: StockVariantType };
    //etc
  };
};
type MenuLinkItem = {
  img: string;
  name: string;
  url: string;
  countries: string[];
};

export type availableReportType = {
  title: string;
  description?: string;
  track?: string;
  config?: string;
  img?: string;
  icon?: string;
  noCropFieldSelection?: boolean;
  versions?: {
    [key in string]: {
      description?: string;
      extraKey: string;
      extraTrack?: string;
    };
  };
  formats: {
    [key in string]: {
      description?: string;
      extraKey: string;
      extraTrack?: string;
    };
  };
};
export type availableReportsType = {
  [key in string]: {
    groupName: string;
    reports: {
      [key in string]: availableReportType;
    };
  };
};
export interface CroprWindow extends Window {
  cropr: Backbone.Events & {
    mainplan: { id: number };
    toLocaleFixed: (
      number: number,
      precision?: number,
      separated?: boolean,
      remove_trailing_zeros?: boolean
    ) => string;
    stock: Backbone.Collection<StockModel>;
    stockPerVariant: StockPerVariantType;
    images: Backbone.Collection<BackboneModel>;
    documents: Backbone.Collection<BackboneModel>;
    cropfields: Backbone.Collection<GeometryModel>;
    all_cropfields: Backbone.Collection<GeometryModel>;
    parcels: Backbone.Collection<GeometryModel>;
    storages: Backbone.Collection<GeometryModel>;
    applications: Backbone.Collection<BackboneModel>;
    way_lines: Backbone.Collection<GeometryModel>;
    farm_contacts: Backbone.Collection<BackboneModel>;
    plans: Backbone.Collection<BackboneModel>;
    machines: Backbone.Collection<BackboneModel>;
    records: Backbone.Collection<RecordModel>;
    contracts: Backbone.Collection<BackboneModel>;
    revenueDefinitions: Backbone.Collection<BackboneModel>;
    detailtype: any;
    l10n: {
      unit_area_display: string;
      unit_currency_sign: string;
      languageCode: string;
      // These properties are set when dacom-online is initialized.
      unit_rain_display?: string;
      unit_depth_display?: string;
    };
    l10n_utils: {
      ha_to_l10n: (ha: number) => number;
      mps_to_l10n: (mps: number) => number;
      celsius_to_l10n: (celsius: number) => number;
      mm_to_l10n: (mm: number) => number;
      gr_per_m2_to_l10n_as_float: (gr_per_m2: number, precision: number) => number;
    };
    share_mode?: boolean;
    features: {
      // TODO review this. Most features are actually numbers.
      customer_module?: boolean;
      soil_data?: boolean;
      weather_forecast?: number;
      export_shape?: boolean;
      edi_export?: boolean;
      import_fms?: boolean;
      photo?: boolean;
      dacom_online_weather?: number;
      cloudfarm?: boolean;
      cloudfarm_contract?: boolean;
      machines?: boolean;
      dacom_online_disease?: boolean;
      dacom_online_disease_contract?: boolean;
      insect?: boolean;
      shared_sensors?: boolean;
      sensetion?: boolean;
      irrigation?: boolean;
      pro?: boolean;
      premium?: boolean;
      admissions?: boolean;
      planning?: boolean;
      report?: boolean;
    };
    addInit: (callback: () => void, event?: string) => void;
    nav_applications_installed: { gid: string; url: string; name: string; img: string }[];
    nav_applications_other: { gid: string; url: string; name: string; img: string }[];
    nav_application_switch: { switch: MenuLinkItem[]; discover: MenuLinkItem[] };
    setFarm: (id: number) => void;
    setActivePlan: (id: number) => void;
    setPlan: (id: number) => void;
    soiltype: { [id: string]: SoilType };
    reg_soiltype: { [id: string]: SoilType };
    fieldattributetype: { [id: string]: FieldAttributeType };
    notify: (type: MessageType, message: string, top_offset?: number, delay?: number) => void;
    confirm: (message: string) => boolean;
    data: Record<string, any>;
    router: any;
    getCookie: (name: string) => string;
    NewCoWorkerView: Backbone.View;
    cache: any;
    user: any;
    farm: any;
    farm_list: any[];
    active_order: any;
    croptype: {
      [key in string | number]: {
        id: number;
        name: string;
        //etc
      };
    };
    cropvariety: {
      [key in string | number]: {
        id: number;
        name: string;
        //etc
      };
    };
    permissions: any;
    getConfig: any;
    metric: any;
    partner_config: any;
    necBrand?: any;
    necAnalysisAppGid?: any;
    recording?: any;
    initContractUtils: () => void;
    contract_warnings?: any; //available after initContractUtils() was called
    theme: any;
    monthToStr: (month: number) => string;
    dayToStr: (day: number) => string;
    my_dataversion: string;
    cloudfarm_domain: string;
    cloudfarm_oauth_token: string;
    getActivePlan: () => PlanModel;
    sfam: {
      advices: Backbone.Collection<DiseaseAdviceModel>;
      cropFieldAdvices: Backbone.Collection<CropfieldAdviceModel>;
      cropFieldGroupAdvices: Backbone.Collection;
      cropFields: Backbone.Collection;
    };
    ceres: {
      apiClient: any;
    };
    getImageUrl: (key: string, options?: any) => string;
    cachedUrlGet: (url: string, options: JQuery.AjaxSettings) => any;
    certificates: Backbone.Collection;
    getAvailableReports: () => availableReportsType;
    cropfieldCostRevenueTypesForCountry: any;
    farmconfigurationview: Backbone.View;
  };
  Model: any;
  Backbone: any;
  django: {
    catalog: any;
  };
}

declare let window: CroprWindow;
export const Model: any = window.Model;
export const Backbone: any = window.Backbone;
export const django: any = window.django;

// _.extend({fillColor: "#e1dfd9", strokeColor:"#58534d"}, options);
export interface BackboneModel extends Backbone.Model {
  propertyType: any;
  getDate: (attr?: string) => moment.Moment;
  getTime: (attr: string) => string;
  getDateTime: (attr: string, format?: string) => string;
  getLocaleDate: (attr: string, format?: string, noyear?: boolean) => string;
  getDateTimeObject: (attr?: string) => moment.Moment;
  getYear: (attr: string) => number;
  getPrintDate: (attr: string) => string;
  getPrintDateTime: (attr: string) => string;
  saveAndAddNewTo: (
    collection: Backbone.Collection,
    attrs: any,
    success?: (modelOrCollection: any, response: JQueryXHR, options?: any) => void,
    error?: (modelOrCollection: any, jqxhr: JQueryXHR, options?: any) => void,
    options?: Backbone.ModelSaveOptions | null
  ) => any;
  getRelated: (property: string, key?: string, relationKey?: string) => any | null;
}

export interface GeometryModel extends BackboneModel {
  getGeometry: () => string;
  getCalculatedArea: () => number;
  getAreaString: (decimalPlaces?: number) => string;
  getCentroid: (toProj?: string) => [number, number];
  getDrawOptions: (options: {
    greyscale?: boolean;
    size?: number;
    fillColor?: string;
    strokeColor?: string;
  }) => { fillColor: string; strokeColor: string };
}

export interface StockModel extends BackboneModel {
  getUnit: () => string;
}
export interface PlanModel extends BackboneModel {}
export interface DiseaseAdviceModel extends BackboneModel {
  mostUrgentAction(): any;
  getAdvice(): any;
}
export interface CropfieldAdviceModel extends BackboneModel {}
export interface ParcelModel extends GeometryModel {}
export interface CropFieldModel extends GeometryModel {}
export interface WayLineModel extends GeometryModel {
  getLength: (f?: any) => number;
  getDisplayAngle: () => number;
  getCropFields: () => CropFieldModel[];
}
export interface RecordModel extends BackboneModel {
  getAreaString: () => string;
  getValueFromActivity: (type_id: number) => any;
  getProductUsage: (producttype_id: number) => number | undefined;
  findActivityItemWhere: (
    where: Record<string, any>,
    activities?: RecordActivity[]
  ) => RecordItem | undefined;
  getArea: () => number;
  getShortApplierName: () => string;
  getAreaDisplay: () => string;
  getOperationList: () => string;
  getItemFromActivity: (type_id: number, activities?: RecordActivity[]) => RecordItem | undefined;
}

export interface RecordAttribute {
  type: number;
  value?: number;
  code?: number;
}

export interface RecordItem {
  type: number;
  value?: number;
  stock?: number;
  name?: string;
  unit: string;
}
export interface RecordActivity {
  type: number;
  stock?: number;
  seedling_stock?: number;
  theme: number;
  attributes?: RecordAttribute[];
  items: RecordItem[];
}

export type Stock = {
  attributes: any;
  cost: number;
  cost_per_unit?: number;
  cropfield?: number;
  farm: number;
  id: number;
  name: string;
  plan: number;
  product_type?: number;
  quantity: number;
  stock_unit: string;
  type: number;
  variant: "f" | "c" | "y" | "s" | "o" | "d";
  crop?: number;
  variety?: number;
};

export interface CropField {
  name: string;
  registered_area: number;
  period_start: string;
  period_end: string;
  previous_crop?: number;
  crop?: number;
  variety?: number;
  specie?: number;
  purpose?: number;

  period?: number;
  consumer?: number;
  contract?: number;

  notes: string;

  owner?: number;
  soil_type?: number;
  soil_texture?: number;
  regulatory_soil_type?: number;
  reference?: string;
  green_manure?: number;
  field_attributes?: Array<any>;
  certificates?: Array<any>;
  soil_researches?: Array<any>;
  attachments?: Array<any>;
  parcel?: number;

  geometry?: string;
  entrance?: string;
}
export interface Parcel {
  name: string;
  registered_area: number;
  owner: number;
  soil_type: number;
  regulatory_soil_type: number;
  attachments: Array<any>;
  geometry: string;
}

export interface StorageAddress {
  id?: number;
  line_1?: string;
  city?: string;
  zipcode?: string;
  country?: string;
}

export interface Storage {
  name: string;
  registered_area?: number;
  type?: "refrigerator" | "outdoor" | "barn";
  bottom_type?: "paved" | "unpaved";
  geometry: string;
  address?: StorageAddress | null;
}

export interface WayLine {
  name: string;
  description: string;
  date: string;
  active: boolean;
  geometry: string;
}

export default window.cropr;
